// extracted by mini-css-extract-plugin
export var Logo = "Logo-module--Logo--1fa1f";
export var mobileLogoText = "Logo-module--mobileLogoText--055cb";